<template>
  <div
    v-if="group"
    id="iframeContainer"
  >
    <iframe
      v-show="loaded"
      id="clicrdv-iframe"
      ref="frame"
      frameBorder="0"
      :src="src"
      @load="iframeLoaded"
    />

    <div
      v-if="!loaded"
      class="card-disabled mt-5"
    >
      <div class="loader" />
    </div>
  </div>
</template>

<script>
const data = () => ({
	src: null,
	loaded: false
});

const iframeLoaded = function (e) {
	if (e.timeStamp > 1000) {
		this.loaded = true;
	}
};

const getUrl = function () {
	if (this.group && this.group.id) {      
		let url = new URL(this.group.urlname, process.env.VUE_APP_PRO_URL);
  
		url.searchParams.set("popin", "1");
		url.searchParams.set("styles", "telesecretariat");
		url.searchParams.set("token_telesecretariat", this.$store.state.token);
  
		this.src = url.toString();
	}
};

export default {
	name: "GroupIframe",
	props: {
		group: {
			type: Object,
			required: true
		}
	},
	data,
	watch: {
		group: function (_val) {
			getUrl.bind(this)();
		},
	},
	mounted() {
		getUrl.bind(this)();
	},
	methods: {
		iframeLoaded
	}
};

let addListenerMethod = (window.addEventListener ? "addEventListener" : "attachEvent"),
	eventName = (window.addEventListener ? "message" : "onmessage");

window[addListenerMethod](eventName, function (e) {
	let iframe = document.getElementById("clicrdv-iframe");
  
	try {      
		if (/https?:\/\/([a-z0-9-]+\.)?clicrdv\.com/.test(e.origin) && iframe) {
			let data = JSON.parse(e.data);
  
			if (data.hasOwnProperty("height")) {
				iframe.style.height = data.height + "px";
			}
		}
	} catch (error) {
		console.error(error);
	}
});
</script>